import React, { createContext } from 'react'

const WordingContext = createContext({
  wording: undefined,
})

export default WordingContext
